<template>
    <div class="project_py">
        <p class="information">
            <span class="information_bar"></span>
            <span class="information_zh">资讯</span>
            <span class="information_en">INFORMATION</span>
        </p>
        <div class="information_con">
            <div class="information_conLeft">
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">濮阳要闻</span>
                        <span @click="newsPuyang('8b6b1c0a-ad07-4dfa-97a5-355fcec9c46d','濮阳要闻')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                        
                    </p>
                    <p v-if="Loading" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div v-if="!Loading" class="content_top" v-for="item in shufflingFunListOne" :key="item.id" @click="columnData(item,'濮阳要闻')">
                        <span class="content_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="content_img" v-if="item.image_url == ''"><img style="width:100%;padding-top: 0.5rem;" src="../images/defaultimg.png" alt=""></span>
                        <div class="content_right">
                            <p class="content_title">{{item.title}}</p>
                            <p class="conent_int" v-html="abstractContent">{{abstractContent}}</p>
                        </div>
                    </div>
                   <ul v-if="!Loading" class="content_list">
                        <li v-for="item in shufflingFunList" :key = "item.id" @click="columnData(item,'濮阳要闻')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
                
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">综合新闻</span>
                        <span  @click="newsPuyang('8ca6804b-d9d3-491e-ade8-76c9b811167b','综合新闻')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span> 
                    </p>
                    <p v-if="Loadingzhxw" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div v-if="!Loadingzhxw" class="content_top" v-for="item in comprehensiveOneList" :key="item.id" @click="columnData(item,'综合新闻')">
                        <span class="content_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="content_img" v-if="item.image_url == ''"><img style="width:100%;padding-top: 0.5rem;" src="../images/defaultimg.png" alt=""></span>
                        <div class="content_right">
                            <p class="content_title">{{item.title}}</p>
                            <p class="conent_int" v-html="comprehensiveContent">{{comprehensiveContent}}</p>
                        </div>
                    </div>
                    <ul v-if="!Loadingzhxw" class="content_list">
                        <li v-for="item in comprehensiveList" :key = "item.id" @click="columnData(item,'综合新闻')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
            </div>

            <div  class="information_conLeft information_conCent">
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">乡村振兴</span>
                        <span @click="newsPuyang('b6fa79eb-d01e-49fe-a033-3fd6f1a8631a','乡村振兴')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                        
                    </p>
                    <p v-if="Loadinglzxw" style="text-align: center;height: 400px;line-height: 400px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div v-if="!Loadinglzxw" class="content_top" v-for="item in dragonParameterOneList" :key="item.id" @click="columnData(item,'龙乡新闻')">
                        <span class="content_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="content_img" v-if="item.image_url == ''"><img style="width:100%;padding-top: 0.5rem;" src="../images/defaultimg.png" alt=""></span>
                        <div class="content_right">
                            <p class="content_title">{{item.title}}</p>
                            <p class="conent_int" v-html="dragonContent">{{dragonContent}}</p>
                        </div>
                    </div>
                    <ul v-if="!Loadinglzxw" class="content_list">
                         <li v-for="item in dragonParameterList" :key = "item.id" @click="columnData(item,'龙乡新闻')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
            </div>
            <div class="information_conLeft information_conRight">
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">电视新闻</span>
                        <span @click="newsPuyang('5da14b3de4b0f0e6b01f37ab','电视新闻')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                    </p>
                    <!-- <p v-if="Loadingsjb" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner type="triple-bounce"></mt-spinner></p> -->
                   
                    <ul class="content_list">
                        <li v-for="item in phoneAbstractList" :key = "item.id" @click="columnData(item,'电视新闻')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
                
                <div class="news_py">
                    <p class="news_title">
                        <span class="name_py">媒体看龙乡</span>
                        <span @click="newsPuyang('a51d184c-0486-4f48-ba73-c7915b1e2ade','媒体看龙乡')">
                            <img src="../images/more.png" alt="">
                            <span class="more_py">更多</span>
                        </span>
                    </p>
                    <p v-if="Loadingwmkpy" style="text-align: center;height: 200px;line-height: 200px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
                    <div v-if="!Loadingwmkpy" class="content_top" v-for="item in mediaAbstractOneList" :key="item.id" @click="columnData(item,'外媒看濮阳')">
                        <span class="content_img" v-if="item.image_url != ''">
                            <img class="cont_images" :src="item.image_url" alt="">
                            <!-- <el-image class="cont_images" :src="item.image_url" lazy></el-image> -->
                        </span>
                        <span class="content_img" v-if="item.image_url == ''"><img style="width:100%;padding-top: 0.5rem;" src="../images/defaultimg.png" alt=""></span>
                        <div class="content_right">
                            <p class="content_title">{{item.title}}</p>
                            <p class="conent_int" v-html="mediaAbstractContent">{{mediaAbstractContent}}</p>
                        </div>
                    </div>
                    <ul v-if="!Loadingwmkpy" class="content_list">
                        <li v-for="item in mediaAbstractList" :key = "item.id" @click="columnData(item,'外媒看濮阳')"><i class="el-icon-caret-right"></i>{{item.title}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {listApi,listDetails,columnList , columnNewsList ,getColumnByParentId,generateSign} from '@/api/index'
import Bus from '@/Bus'

// 濮阳新闻
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "8b6b1c0a-ad07-4dfa-97a5-355fcec9c46d",
    userId: "",
    appInfoId: "10"
}
const shufflingAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
// 龙乡新闻 综合
const dragonTownship = {
    pageNum: 0,
    pageSize: 13,
    columnId: "b6fa79eb-d01e-49fe-a033-3fd6f1a8631a",
    userId: "",
    appInfoId: "10"
}
const dragonAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
// 综合新闻
const comprehensive = {
    pageNum: 0,
    pageSize: 12,
    columnId: "8ca6804b-d9d3-491e-ade8-76c9b811167b",
    userId: "",
    appInfoId: "10"
}
const comprehensiveAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}

// 手机报
const phoneParameter = {
    pageNum: 0,
    pageSize: 12,
    columnId: "5da14b3de4b0f0e6b01f37ab",
    userId: "",
    appInfoId: "10"
}
const phoneAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}

// 外媒看濮阳
const mediaParameter = {
    pageNum: 0,
    pageSize: 12,
    columnId: "a51d184c-0486-4f48-ba73-c7915b1e2ade",
    userId: "",
    appInfoId: "10"
}
const mediaAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}

export default {
    data(){
        return {
            Loading:true,
            Loadingzhxw:true,
            Loadinglzxw:true,
            Loadingsjb:true,
            Loadingwmkpy:true,

            jumpRouting:true,
            defaultImg:'../images/defaultimg.png',
            // 濮阳新闻
            shuParameter: Object.assign({}, shufflingParameter),
            shufflingAbstractOne: Object.assign({}, shufflingAbstract),
            shufflingFunList:null,
            shufflingFunListOne:null,
            abstractContent:null,

            // 龙乡新闻  综合
            dragonParameter: Object.assign({}, dragonTownship),
            dragonAbstractOne: Object.assign({}, dragonAbstract),
            dragonParameterOneList:null,
            dragonParameterList:null,
            dragonContent:null,

            // 综合新闻
            comprehensiveParameter: Object.assign({}, comprehensive),
            comprehensiveOne: Object.assign({}, comprehensiveAbstract),
            comprehensiveOneList:null,
            comprehensiveList:null,
            comprehensiveContent:null,

            // 手机报
            phoneNewsParameter: Object.assign({}, phoneParameter),
            phoneAbstractOne: Object.assign({}, phoneAbstract),
            phoneAbstractOneList:null,
            phoneAbstractList:null,
            phoneAbstractContent:null,

            // 外媒看濮阳
            mediaNewsParameter: Object.assign({}, mediaParameter),
            mediaAbstractOne: Object.assign({}, mediaAbstract),
            mediaAbstractOneList:null,
            mediaAbstractList:null,
            mediaAbstractContent:null,

        }
    },
    created(){
        this.shufflingFuns()
        this.townshipFuns()
        this.comprehensiveFuns()
        this.mediaFuns()
        this.phoneFuns()
    },
    methods:{
        
        // 濮阳新闻
        async shufflingFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.shuParameter,{ headers })
            this.shufflingFunListOne = res.data.data[0].list.splice(0,1)
            this.shufflingFunList = res.data.data[0].list.splice(0,2)
            this.shufflingAbstractOne.id = this.shufflingFunListOne[0].id
            this.axios.post(listDetails,this.shufflingAbstractOne,{ headers }).then(res => {
                this.abstractContent = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                this.Loading = false
            })
        },
        // 龙乡新闻 综合
        async townshipFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.dragonParameter,{ headers })
            this.dragonParameterOneList= res.data.data[0].list.splice(0,1)
            this.dragonParameterList = res.data.data[0].list.splice(0,11)
            this.dragonAbstractOne.id = this.dragonParameterOneList[0].id
            this.axios.post(listDetails,this.dragonAbstractOne,{ headers }).then(res => {
                this.dragonContent = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                this.Loadinglzxw = false
            })
        },
        // 综合新闻 
        async comprehensiveFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.comprehensiveParameter,{ headers })
            this.comprehensiveOneList= res.data.data[0].list.splice(0,1)
            this.comprehensiveList = res.data.data[0].list.splice(0,2)
            this.comprehensiveOne.id = this.comprehensiveOneList[0].id
            this.axios.post(listDetails,this.comprehensiveOne,{ headers }).then(res => {
                this.comprehensiveContent = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                this.Loadingzhxw = false
            })
        },

        // 手机报
        async phoneFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.phoneNewsParameter,{ headers })
            console.log('123');
            
            // this.phoneAbstractOneList= res.data.data[0].list.splice(0,1)
            this.phoneAbstractList = res.data.data[0].list.slice(0,7)
            this.phoneAbstractOne.id = this.phoneAbstractOneList[0].id
            this.axios.post(listDetails,this.phoneAbstractOne,{ headers }).then(res => {
                this.phoneAbstractContent = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                this.Loadingsjb = false
            })
        },

        // 外媒看濮阳
        async mediaFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(columnNewsList,this.mediaNewsParameter,{ headers })
            this.mediaAbstractOneList= res.data.data[0].list.splice(0,1)
            this.mediaAbstractList = res.data.data[0].list.splice(0,2)
            this.mediaAbstractOne.id = this.mediaAbstractOneList[0].id
            this.axios.post(listDetails,this.mediaAbstractOne,{ headers }).then(res => {
                this.mediaAbstractContent = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                this.Loadingwmkpy = false
            })
        },


        // 列表详情跳转
        columnData(type,title){
            let routeData = this.$router.resolve({ path: '/details', query: {  id: type.id,jsonUrl:type.jsonUrl,title } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        // 获取濮阳新闻更多列表
        newsPuyang(columnId,title){
            let routeData = this.$router.resolve({ path: '/announphones', query: {  columnId ,title} });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        }
    }
}
</script>
<style lang="">
    .conent_int div img{
        display:none !important;
    }
    .conent_int p img{
        display:none !important;
    }
    .conent_int div span img{
        display:none !important;
    }
    .conent_int p span img{
        display:none !important;
    }
    .conent_int p span{
        font-size:12px !important;
        line-height: 20px !important;
        color:#646464;
    }
    .conent_int div span{
        font-size:12px !important;
        line-height: 20px !important;
        color:#646464 !important;
    }
    .conent_int p{
        font-size:12px !important;
        line-height: 20px !important;
        color:#646464;
    }
    .conent_int div{
        font-size:12px !important;
        line-height: 20px !important;
        color:#646464;
    }
    .project_py{
        margin-top:44px;
        border-top:2px solid rgba(201,3,4,1);
    }
    .project_py .information{
        height:45px;
        line-height:45px;
        border-bottom:1px solid rgba(210,210,210,1);;
    }
    .information  .information_bar{
        margin:0 10px 0 16px;
        border-left:3px solid rgba(201,3,4,1);
    }
    .information .information_zh{
         height:18px;
         color:rgba(201,3,4,1);
         font-size:18px;
         font-weight: bolder;
    }
    .information .information_en{
        font-size: 18px;
        color:#646464;
        font-weight: 400;
        margin-left:10px;
    }
    .information_con{
        height:540px;
        padding-top:24px;
    }
    .information_con .information_conLeft{
        float:left;
        width:386px;
    }
    .information_con .information_conRight{
        float:right;
        width:386px;
    }
    .information_conCent{
        margin-left:21px;
    }
    .information_conLeft .news_py{
        height:276px;
    }
    .information_conLeft .news_py .news_title{
        height:40px;
        line-height:40px;
        border-top:1px solid #D2D2D2;
        border-bottom:1px solid #D2D2D2;
        background:rgba(235, 233, 233, 0.5);
    }
    .information_conLeft .news_py .name_py{
        width:68px;
        color:#000;
        font-size: 16px;
        font-weight: bolder;
        border-top:2px solid #C90304;
        padding-top:8px;
        margin-left:10px;
    }
    .information_conLeft .news_py .more_py{
        cursor:pointer; 
        font-size: 12px;
        font-weight: 400;
        width:28px;
        float:right;
        color:#969696;
    }
    .information_conLeft .news_py p img{
        width:14px;
        height:14px;
        float:right;
        padding-top:13px;
        cursor:pointer; 
        padding-right: 6px;
    }
    .content_top{
        margin-top:18px;
        cursor:pointer;
    }
    .content_top .content_img{
        width:183px;
        height:137px;
        display:inline-block;
    }
    .content_top .content_img .cont_images{
        width:100%;
        height:100%;
    }
    .content_right{
        width:168px;
        height:137px;
        float:right;
        padding: 0 17px;
    }
    .content_right .content_title{
        margin-top:6px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        color:#C90304;
        font-size:16px;
    }
    .content_right .conent_int{
        overflow: hidden;
        height: 6rem;
        margin-top:8px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        font-size:12px;
        line-height:20px;
        color:#646464;
    }
    .content_list{
        padding-top:0.16rem;
    }
    .content_list li{
        cursor:pointer;
        overflow: hidden;
        border-bottom:0.5px dashed #DCDCDC;
        text-overflow:ellipsis;
        white-space: nowrap;
        width:386px;
        font-size:16px;
        line-height:30px;
    }
    .content_list i{
        color:#F8696A;
        margin-right:10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/projectAtra.vue